









































import { Vue, Component, Prop } from "vue-property-decorator";
import * as data from "../_store/data.module";
import { bus } from "../main";
import * as user from "../_store/user.module";
import CreateDialog from "../components/Dialogs/CreateDialog.vue";

@Component({
  components: {
    CreateDialog
  }
})
export default class FoglioFirme extends Vue {
  @Prop() nomeSoggetto!: string;
  @Prop() idRichiesta!: number;
  @Prop() soggetto!: string;
  @Prop() activityType!: string;
  @Prop() info!: any;

  private listaFirme: any;
  private searchFoglioFirme: string;
  private loadingDataFirme: boolean;
  private headers: any;
  private createDialogParams: any;
  private totOre: number;
  private conclusaAttivita: boolean;

  private showCreateDialog: boolean;

  constructor() {
    super();
    this.listaFirme = [];
    this.searchFoglioFirme = "";
    this.loadingDataFirme = true;
    this.headers = [
      {
        text: "Data",
        value: "dataFirma",
        sortable: false
      },
      {
        text: "Orario Mattino",
        value: "orarioMattino",
        sortable: false
      },
      {
        text: "Orario Pomeriggio",
        value: "orarioPomeriggio",
        sortable: false
      },
      {
        text: "Ore",
        value: "oreGiornaliere",
        sortable: false
      },
      {
        text: "",
        value: "modificaGiornoFirma",
        align: "center",
        sortable: false
      }
    ];
    this.createDialogParams = {
      visible: true,
      type: "nuovaFirma",
      idRichiesta: this.idRichiesta,
      soggetto: this.soggetto,
      activityType: this.activityType
    };
    this.totOre = 0;
    this.conclusaAttivita = false;
    this.showCreateDialog = true;
  }

  loadFirme() {
    var payload = {
      idRichiesta: this.idRichiesta,
      activityType: this.activityType
    };
    data
      .dispatchElencoFirme(this["$store"], payload)
      .then(result => {
        this.listaFirme = result;
        this.loadingDataFirme = false;
        if (result[0].idStatoAccettazione === 4) {
          this.conclusaAttivita = true;
        }
        this.totOre = 0;
        for (let i = 0; i < result.length; i++) {
          this.totOre = this.totOre + result[i].oreGiornaliere;
        }
      })
      .catch(error => {
        if (error.response.status === 403) {
          bus.$emit("errorOperation", error.response.statusText);
          this["$router"].push("/login");
        } else {
          bus.$emit("errorOperation", error.response.statusText);
        }
      });
  }

  deleteGiorno(giorno: any) {
    var payload = {
      idFirma: giorno.idFirma
    };
    var str: string = "Eliminare il giorno " + giorno.dataFirma + "?";
    if (confirm(str)) {
      user
        .dispatchDeleteGiornoFoglioFirme(this["$store"], payload)
        .then(() => {
          bus.$emit("successfullOperation", "Data cancellata con successo");
          this.loadFirme();
        })
        .catch(error => {
          if (error.response.status === 403) {
            bus.$emit("errorOperation", error.response.statusText);
            this["$router"].push("/login");
          } else {
            bus.$emit("errorOperation", error.response.statusText);
          }
        });
    }
  }

  created() {
    this.loadFirme();

    bus.$on("loadFirme", async () => {
      this.showCreateDialog = false
      await this.$nextTick()
      this.showCreateDialog = true
      this.loadFirme();
    });
  }
}
